import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'EQ 2 – Self-Regulation',
  slug: 'eq-2-self-regulation',
  category: 'EQ',
  date: '2025-05-16',
  image: '',
  excerpt: 'Self management.',
  body: `Self-regulation, or self-management, is the ability to set aside an immediate emotional reaction in order to pursue a longer-range goal. It's the ability to pause, reflect, and redirect a reaction to a difficult stimulus. Here are some ideas to improve:

1. Breathe. Take a deep breath. Focus on it filling your lungs. Hold it. Slowly let it out. See how your body feels.
2. Count to ten. Didn't work? Count to a hundred. The point is, give yourself a timeout where you are actively thinking about nothing but the numbers it takes to get you to ten. Or a hundred.
3. Emotions vs. Rationalism. Make a list of what your emotions are telling you. On the other side of the page, write down some rational thoughts and actions. This is not to ignore the emotions, but to balance your experience with something that has you disturbed.
4. Sleep on it. Give it some time. Don't make decisions when upset.
5. Smile. Laugh. Make your physical body reflect something happy. It can help actually change how you feel.
6. Stop ruminating. Don't let yourself revisit the resentment. Or fear. Or shame.
7. Don't tell yourself "I always…" or "I never…". It's not true. It might be something you do a lot, but don't beat yourself up with a self-fulfilling prophecy that keeps you in a bad loop.
8. Visualize success. What would a win look like? Be specific.
9. Focus on gratitude, not the negative feelings. Gratitude > fear. Gratitude > shame. Gratitude > resentment.
10. Get an outside perspective. Talk to a trusted friend or counselor. When you're emotional, you might not be a reliable narrator of your own situation.
11. Learn from EVERYONE. Let a challenge become a lesson. When you get upset, try to see the lesson.`,
}

export default post
